import React from 'react';
import { ShieldCheck, Award } from 'lucide-react';

export const Official = () => {
  return (
    <section className="py-16 lg:py-20 bg-gradient-to-br from-blue-950 via-blue-900 to-blue-950 relative overflow-hidden">
      {/* Decorative elements - tricolor stripes */}
      <div className="absolute top-0 left-0 right-0 h-1 flex">
        <div className="flex-1 bg-yellow-400"></div>
        <div className="flex-1 bg-blue-700"></div>
        <div className="flex-1 bg-red-600"></div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-1 flex">
        <div className="flex-1 bg-yellow-400"></div>
        <div className="flex-1 bg-blue-700"></div>
        <div className="flex-1 bg-red-600"></div>
      </div>

      {/* Subtle pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 w-64 h-64 bg-yellow-400 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-64 h-64 bg-red-500 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Badge */}
          <div className="text-center mb-8">
            <div className="inline-flex items-center gap-2 bg-yellow-400 text-blue-950 px-5 py-2 rounded-full text-sm font-black tracking-wider">
              <Award size={18} strokeWidth={2.5} />
              PRODUCTO OFICIAL CON LICENCIA
            </div>
          </div>

          {/* Main Content */}
          <div className="grid lg:grid-cols-[1fr_auto_1fr] gap-8 lg:gap-12 items-center">
            {/* Logo FEF */}
            <div className="flex flex-col items-center lg:items-end">
              <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-6 lg:p-8 border border-white/10 hover:border-yellow-400/50 transition-all duration-300 hover:scale-105">
                <img 
                  src="https://customer-assets.emergentagent.com/job_sunglass-hub-6/artifacts/mfp1k1ko_logo-federacion-ecuatoriana-futbol.png" 
                  alt="Federación Ecuatoriana de Fútbol"
                  className="h-28 lg:h-36 w-auto object-contain"
                 loading="lazy" decoding="async" />
              </div>
              <div className="text-center lg:text-right mt-4">
                <div className="text-yellow-400 font-bold text-sm tracking-wider">AUTORIZADO POR</div>
                <div className="text-white font-bold text-lg lg:text-xl mt-1">FEF</div>
                <div className="text-blue-200 text-sm">Federación Ecuatoriana de Fútbol</div>
              </div>
            </div>

            {/* Center - Copy */}
            <div className="text-center max-w-md mx-auto">
              <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10">
                <ShieldCheck className="text-yellow-400 mx-auto mb-3" size={48} strokeWidth={2} />
                <h2 className="text-2xl lg:text-3xl font-black text-white mb-3 leading-tight">
                  Las únicas gafas
                  <span className="block text-yellow-400">oficiales de La Tri</span>
                </h2>
                <p className="text-blue-100 text-base leading-relaxed">
                  Producto licenciado y autorizado oficialmente por la Federación Ecuatoriana de Fútbol. Cada par lleva el respaldo y la pasión de nuestra Tri.
                </p>
              </div>
            </div>

            {/* Logo La Tri */}
            <div className="flex flex-col items-center lg:items-start">
              <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-6 lg:p-8 border border-white/10 hover:border-yellow-400/50 transition-all duration-300 hover:scale-105">
                <img 
                  src="https://customer-assets.emergentagent.com/job_sunglass-hub-6/artifacts/p2yg6jt7_logo-la-tri-ecuador.png" 
                  alt="La Tri - Selección Ecuatoriana"
                  className="h-28 lg:h-36 w-auto object-contain"
                 loading="lazy" decoding="async" />
              </div>
              <div className="text-center lg:text-left mt-4">
                <div className="text-yellow-400 font-bold text-sm tracking-wider">EN ALIANZA CON</div>
                <div className="text-white font-bold text-lg lg:text-xl mt-1">La Tri</div>
                <div className="text-blue-200 text-sm">Selección Ecuatoriana de Fútbol</div>
              </div>
            </div>
          </div>

          {/* Trust Indicators */}
          <div className="mt-12 pt-8 border-t border-white/10 grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
            <div className="flex items-center justify-center gap-3 text-white">
              <div className="bg-yellow-400 text-blue-950 rounded-full p-2">
                <ShieldCheck size={20} strokeWidth={2.5} />
              </div>
              <div className="text-left">
                <div className="font-bold">100% Auténtico</div>
                <div className="text-blue-200 text-xs">Producto certificado</div>
              </div>
            </div>
            <div className="flex items-center justify-center gap-3 text-white">
              <div className="bg-yellow-400 text-blue-950 rounded-full p-2">
                <Award size={20} strokeWidth={2.5} />
              </div>
              <div className="text-left">
                <div className="font-bold">Licencia Oficial</div>
                <div className="text-blue-200 text-xs">Avalado por la FEF</div>
              </div>
            </div>
            <div className="flex items-center justify-center gap-3 text-white">
              <div className="bg-yellow-400 text-blue-950 rounded-full p-2">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="text-left">
                <div className="font-bold">Calidad Garantizada</div>
                <div className="text-blue-200 text-xs">Estándar internacional</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Official;
